import React from "react"
import { useTranslation } from "react-i18next"

const CustomRowPriceAlertRulename = ({ row }) => {
    const [t] = useTranslation()

    let html_email

    let emaillisthtml = []
    row?.mails?.forEach((element) => {
        emaillisthtml.push(<div>{element}</div>)
    })
    html_email = <div>E-Mail: {emaillisthtml}</div>

    return (
        <div className="mt-2 mb-2">
            <div>
                <strong>{row?.name}</strong>
            </div>
            <div>
                User: {row?.userName}
            </div>
            {html_email}
            <div>
                {t("single.checkType")}: {t("single." + row?.checkType)}
            </div>
        </div>
    )
}

const CustomRowPriceAlertRule = ({ row }) => {
    const [t] = useTranslation()

    return (
        <div className="mt-2 mb-2">
            <div>
                {t("single.rule")}: {t("single." + row?.rule?.ruleCheck)}
            </div>
            {row?.rule?.ruleValue && (
                <div>
                    {t("single.ruleValue")}: {row?.rule?.ruleValue}
                </div>
            )}
            {row?.rule?.rulePercent && (
                <div>
                    {t("single.rulePercent")}: {row?.rule?.rulePercent}
                </div>
            )}
            {row?.rule?.minCustomerPriceForProductValidation && (
                <div>
                    {t("single.minCustomerPrice")}: {row?.rule?.minCustomerPriceForProductValidation}
                </div>
            )}
            {row?.rule?.priceDiffToCustomerPriceInPercent && (
                <div>
                    {t("single.priceDiffToCustomerPrice")}: {row?.rule?.priceDiffToCustomerPriceInPercent}
                </div>
            )}
            {row?.rule?.priceDifferenceType && (
                <div>
                    {t("single.priceDiffType")}: {t("single." + row?.rule?.priceDifferenceType)}
                </div>
            )}
            {row?.rule?.exportType && (
                <div>
                    {t("single.exportType")}: {t("single." + row?.rule?.exportType)}
                </div>
            )}
            {row?.rule?.lowerPriceLimit !== 0 && (
                <div>
                    {t("single.lowerPriceLimit")} {row?.rule?.lowerPriceLimit}
                </div>
            )}
            {row?.rule?.referencePriceField && (
                <div>
                    {t("single.referencePrice")}: {t("single." + row?.rule?.referencePriceField)}
                </div>
            )}
            {row?.rule?.priceDiffMarge && (
                <div>
                    {t("single.priceDiffMarge")}: {row?.rule?.priceDiffMarge + " %"}
                </div>
            )}
        </div>
    )
}

const CustomRowPriceAlertSettings = ({ row, shops, producers }) => {
    const [t] = useTranslation()

    let html_shops, html_department, html_product_group, html_product_category, html_producer, html_products

    if (row?.rule?.shopIds?.length > 0) {
        let shopslisthtml = []
        row?.rule?.shopIds?.forEach((element) => {
            let shop = shops?.find((e) => e.value == element)
            if (shop?.label) {
                shopslisthtml.push(
                    <div>
                        <span className={"fi fi-" + shop.lang} /> {shop.label}
                    </div>
                )
            }
        })

        html_shops = (
            <div>
                {t("single.shops")}: {shopslisthtml}
            </div>
        )
    }

    if (row?.rule?.producerIds?.length > 0) {
        let producerslisthtml = []
        row?.rule?.producerIds?.forEach((element) => {
            let producer = producers?.find((e) => e.value == element)
            if (producer?.label) {
                producerslisthtml.push(producer.label)
            }
        })
        html_producer = (
            <div>
                {t("single.manufacturer")}: {producerslisthtml.join(", ")}
            </div>
        )
    }
    if (row?.rule?.department) {
        html_department = (
            <div>
                {t("single.department")}: {row.rule.department.join(", ")}
            </div>
        )
    }
    if (row?.rule?.productGroup) {
        html_product_group = (
            <div>
                {t("single.product_group")}: {row.rule.productGroup.join(", ")}
            </div>
        )
    }
    if (row?.rule?.productCat) {
        html_product_category = (
            <div>
                {t("single.product_category")}: {row.rule.productCat.join(", ")}
            </div>
        )
    }
    if (row?.rule?.productIds?.length > 0) {
        html_products = (
            <div>
                {t("single.productnr")}: {row.rule.productIds.join(", ")}
            </div>
        )
    }

    return (
        <div className="mt-2 mb-2">
            {html_shops}
            {html_department}
            {html_producer}
            {html_products}
            {html_product_group}
            {html_product_category}
        </div>
    )
}

export { CustomRowPriceAlertRulename, CustomRowPriceAlertRule, CustomRowPriceAlertSettings }
